import { ContextModalProps } from '@mantine/modals'
import {
  FabricVariantForm,
  PillowVariantForm,
  PremadeVariantForm,
  TableVariantForm,
  TowelVariantForm,
} from 'components/productDetails/VariantForm'
import { useEditVariant } from 'hooks/variants'
import {
  Category,
  FabricVariant,
  FabricVariantFields,
  PillowVariant,
  PillowVariantFields,
  PremadeVariant,
  PremadeVariantFields,
  TableVariant,
  TableVariantFields,
  TowelVariant,
  TowelVariantFields,
} from 'types/products'

type FabricProps = {
  variant: FabricVariant
  category: Category.FABRIC
}

type PremadeProps = {
  variant: PremadeVariant
  category: Category.PREMADE
}

type PillowProps = {
  variant: PillowVariant
  category: Category.PILLOW
}

type TowelProps = {
  variant: TowelVariant
  category: Category.TOWEL
}

type TableProps = {
  variant: TableVariant
  category: Category.TABLE
}

type Props = FabricProps | PremadeProps | PillowProps | TowelProps | TableProps

export default function EditVariantModal({ context, id, innerProps: { variant, category } }: ContextModalProps<Props>) {
  const edit = useEditVariant()

  async function submitFabric(values: FabricVariantFields) {
    await edit.mutateAsync({
      ...values,
      category: Category.FABRIC,
      id: variant.id,
      size: values.size.toString(),
    })
  }

  async function submitPremade(values: PremadeVariantFields) {
    await edit.mutateAsync({
      ...values,
      category: Category.PREMADE,
      id: variant.id,
      size: `${values.width}x${values.height}`,
    })
  }

  async function submitPillow(values: PillowVariantFields) {
    await edit.mutateAsync({
      ...values,
      category: Category.PILLOW,
      id: variant.id,
    })
  }

  async function submitTowel(values: TowelVariantFields) {
    await edit.mutateAsync({
      ...values,
      category: Category.TOWEL,
      id: variant.id,
      size: `${values.width}x${values.length}`,
    })
  }

  async function submitTable(values: TableVariantFields) {
    await edit.mutateAsync({
      ...values,
      category: Category.TABLE,
      id: variant.id,
      size: `${values.width}x${values.length}`,
    })
  }

  if (category === Category.FABRIC) {
    return (
      <FabricVariantForm
        actionType="edit"
        onSubmit={submitFabric}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          ...variant,
          size: parseInt(variant.size),
        }}
      />
    )
  } else if (category === Category.PREMADE) {
    return (
      <PremadeVariantForm
        actionType="edit"
        onSubmit={submitPremade}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          ...variant,
          width: parseInt(variant.size.split('x')[0]),
          height: parseInt(variant.size.split('x')[1]),
        }}
      />
    )
  } else if (category === Category.PILLOW) {
    return (
      <PillowVariantForm
        actionType="edit"
        onSubmit={submitPillow}
        onCancel={() => context.closeModal(id)}
        initialValues={variant}
      />
    )
  } else if (category === Category.TOWEL) {
    return (
      <TowelVariantForm
        actionType="edit"
        onSubmit={submitTowel}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          ...variant,
          width: parseInt(variant.size.split('x')[0]),
          length: parseInt(variant.size.split('x')[1]),
        }}
      />
    )
  } else if (category === Category.TABLE) {
    return (
      <TableVariantForm
        actionType="edit"
        onSubmit={submitTable}
        onCancel={() => context.closeModal(id)}
        initialValues={{
          ...variant,
          width: parseInt(variant.size.split('x')[0]),
          length: parseInt(variant.size.split('x')[1]),
        }}
      />
    )
  }
}
